import React from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { Space } from "antd";
import { Typography, Divider, Input, Button, Select } from "../core";
import { addSizer } from "../redux/Action/Sizer/sizer";
import { theme } from "../styles";
import {
  UserOutlined,
  NumberOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  DollarOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import { Form, Row, Col } from "antd";
import { getCompanyId } from "../helper/utils/companyId";
const Notify_Utils = require("../helper/utils/Notification");

const { colors } = theme;

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyldForm = styled(Form)`
  label,
  .buttton_btn,
  .buttton_btn:hover {
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;

    color: ${colors.darkPink};
  }
  .buttton_btn {
    padding: 0px;
  }
`;
const AddSizerForm = () => {
  let Error = useSelector((state) => state.errorReducer);
  const dispatchToAction = useDispatch();
  const [sizer, setsizer] = React.useState({});
  const yarnQuality = useSelector(
    (state) => state.yarnQualityReducer.yarnQuality
  );
  const { token } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    dispatchToAction(addSizer(sizer, token));

    form.resetFields();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const onValuesChange = (changed, values) => {
    const {
      sizer_name,
      ntn_sizer,
      strn_sizer,
      address_sizer,
      phone_no_sizer,
      sizer_quality_rate,
    } = values;

    setsizer((prev) => ({
      ...prev,
      company_id: getCompanyId(),
      sizer_name,
      ntn_sizer,
      strn_sizer,
      address_sizer,
      phone_no_sizer,
      sizer_quality_rate,
    }));
  };
  return (
    <React.Fragment>
      {Error.id === "ADD_SIZER_FAIL" ? (
        Object.values(Error.msg).map((items, index) => {
          return Notify_Utils.openNotificationWithIcon(
            "error",
            `${items[0]}`,
            "white"
          );
        })
      ) : Error.id === "ADD_SIZER_SUCCESS" ? (
        <>
          {Notify_Utils.openNotificationWithIcon("success", Error.msg)},
          <Redirect to="/sizer-list" />
        </>
      ) : null}
      <StyldForm
        form={form}
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[{ xs: 0, sm: 48 }, 16]} type="flex" justify="center">
          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle=" General Info" />
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="sizer_name"
              label="Sizer Name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Sizer Name",
                },
              ]}
            >
              <Input placeholder="Sizer name" prefix={<UserOutlined />} />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="ntn_sizer"
              label="NTN Sizer"
              rules={[
                {
                  required: true,
                  message: "Please select Ntn Number ",
                },
              ]}
            >
              <Input placeholder="NTN" prefix={<NumberOutlined />} />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="strn_sizer"
              label="STRN "
              rules={[
                {
                  required: true,
                  message: "Please select Strn Number ",
                },
              ]}
            >
              <Input placeholder="STRN" prefix={<NumberOutlined />} />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="address_sizer"
              label="Sizer Address "
              rules={[
                {
                  required: true,
                  message: "Please Set Address!",
                },
              ]}
            >
              <Input placeholder="Address" prefix={<EnvironmentOutlined />} />
            </Form.Item>
          </Col>

          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="phone_no_sizer"
              label="Phone #"
              rules={[
                {
                  required: true,
                  message: "Please Enter Phone!",
                },
              ]}
            >
              <Input
                placeholder="Phone"
                prefix={<PhoneOutlined rotate={90} />}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}></Col>
          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle="Sizer Rate" />
          </Col>
          <Col md={16} sm={18} xs={24}>
            <Form.List name="sizer_quality_rate">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    {fields.map((field) => (
                      <Space
                        key={field.key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="start"
                      >
                        <Form.Item
                          {...field}
                          label="Yarn Quality"
                          name={[field.name, "quality"]}
                          fieldKey={[field.fieldKey, "quality"]}
                          rules={[
                            {
                              required: true,
                              message: "Please select yarn Quality ",
                            },
                          ]}
                        >
                          <Select
                            placeholder="count / con size / brand / type"
                            type="sizeryarnQualities"
                            prefixIcon={<UserOutlined />}
                            Options={yarnQuality ? yarnQuality : []}
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          label="Rate"
                          name={[field.name, "rate_per_kg"]}
                          fieldKey={[field.fieldKey, "rate_per_kg"]}
                          rules={[
                            {
                              required: true,
                              message: "Input Metter",
                            },
                          ]}
                        >
                          <Input
                            type="number"
                            placeholder="Rate"
                            prefix={<DollarOutlined />}
                          />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                      </Space>
                    ))}

                    <Form.Item>
                      <Button
                        width="187px"
                        margin="0px"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined />
                        Add Sizer Rates
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          <Col md={8} sm={18} xs={24}></Col>
        </Row>
        <Form.Item>
          <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
            <Typography
              text="Add Sizer"
              as="h5"
              noMargin
              weight="bold"
              align="center"
              color="white"
            />
          </Button>
        </Form.Item>
      </StyldForm>
    </React.Fragment>
  );
};

const SubTiitle = ({ tittle }) => {
  return (
    <div>
      <div className="d-flex v-center">
        <Divider
          width="8px"
          radius="2px"
          height="30px"
          margin="0px 5px"
          type="vertical"
        />
        <Typography
          className="d-inline--block"
          as="h3"
          noMargin
          color={colors.darkPink}
          weight="bold"
          text={tittle}
        />
      </div>
    </div>
  );
};

export default AddSizerForm;
